import { ReactNode } from "react";

export const HeaderMainContent = ({
  label,
  child,
}: {
  label: string;
  child?: ReactNode;
}) => {
  return (
    <div className="main-content-header flex-container align-center justify-between padd-18">
      <h3 className="blue-text">{label}</h3>
      {child}
    </div>
  );
};
